import { useState, useRef, useEffect } from "react";
import { ChatClientDB } from "../../../db";
import {
  Box,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Stack
} from "@mui/material";
import ChatHeader from "./ChatHeader";
import ChatInput from "./ChatInput";
import { useSelector } from "react-redux";
import { Getrequestcall } from "../../../request/Getrequest";
import {
  CLIENT_SAVE_CHAT_MEDIA_MASSAGES,
  CLIENT_SAVE_MESSAGE_PITURES,
  GET_CHAT_GROUP_MESSAGES_CLIENT,
  SEND_CHAT_GROUP_FIREBASE_NOTIFY
} from "../../../constant/Apipath";
import ChatAudioRecorder from "../../../user/chat/ChatAudioRecorder";
import { HubConnectionState } from "@microsoft/signalr";
import CloseIcon from "@mui/icons-material/Close";
import { Fileuploadrequestcall } from "../../../request/Fileuploadrequest";
import { Postrequestcall } from "../../../request/Postrequest";
import Message from "../../../common/Messages";
import ChatLoader from "../../../common/ChatLoader";
import BuildIdEvent, { BuildIdClientEventListener } from "../../../common/BuildIdEvent";
import SignalR from "../../../common/SignalR";

const TAG = "ChatUI";
const MSG_TYPE = {
  TEXT: 1,
  IMAGE: 2,
  LINK: 3,
  AUDIO: 4
};
const ChatUI = ({
  selectedChat,
  onBack,
  clientId,
  selectedClientData,
  isSmallScreen,
  error,
  setError
}) => {
  const { loginData } = useSelector((state) => state?.main);
  const chatGroupId = selectedChat?.chatGroupId;
  const userId = loginData?.userInformation?.UserId;
  const [messages, setMessages] = useState([]);
  const [loading, setLoding] = useState(false);
  const chatContainerRef = useRef(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [audioRecorder, setAudioRecorder] = useState(false);
  const buildIdEvent = BuildIdEvent();

  useEffect(() => {
    // Clear messages immediately to avoid showing previous chat data
    setMessages([]);

    if (chatGroupId === 0 || userId === 0) {
      setError("");
      return;
    }
    let isMounted = true;

    const processChatGroupDetails = async (targetGroupId, targetClientId = clientId) => {
      try {
        await buildIdEvent.sendChatGroupDetails(targetGroupId, true, targetClientId);
      } catch (err) {
        console.error("processChatGroupDetails-> Error: ", err);
      }
    };

    const initializeListener = () => {
      SignalR.connectionStatusListener((status) => {
        if (status === HubConnectionState.Connected) {
          setListener();
          processChatGroupDetails(chatGroupId);
        } else {
          console.warn(`${TAG}-> SignalR not connected (Status: ${status})`);
        }
      }, TAG);
    };

    const getMessages = async () => {
      // 1. Try Loading from Local DB
      try {
        const localMessages = await ChatClientDB.client_messages
          .where("chatGroupId")
          .equals(chatGroupId)
          .sortBy("dateSent"); // Sorted by date

        if (localMessages && localMessages.length > 0) {
          setMessages(localMessages);
        } else {
          setLoding(true); // Only show loader if no local data
        }
      } catch (err) {
        console.error("Local DB load error:", err);
        setLoding(true);
      }

      // 2. Fetch from API
      try {
        const res = await Getrequestcall(
          `${GET_CHAT_GROUP_MESSAGES_CLIENT}/${userId}/${chatGroupId}/${1}/200/${loginData?.ChatLanguage}`,
          loginData?.accessToken
        );

        // Check if component is still mounted and chatGroupId hasn't changed
        if (!isMounted) return;

        if (res.status) {
          const apiMessages = res?.data?.data || [];

          // Inject chatGroupId into messages before saving
          const messagesToSave = apiMessages.map((msg) => ({
            ...msg,
            chatGroupId: chatGroupId // Ensure this link exists
          }));

          setMessages(messagesToSave);

          // 3. Save to Local DB (Overwrite/Update)
          try {
            await ChatClientDB.transaction("rw", ChatClientDB.client_messages, async () => {
              // Strategy: You might want to delete old ones or just put.
              // If we use put, it updates by ID.
              // If we want to ensure we sync deletions, we might need a clear strategy,
              // but for now, let's bulkPut to update/add.
              await ChatClientDB.client_messages.bulkPut(messagesToSave);
            });
          } catch (dbErr) {
            console.error("Failed to save messages to local DB:", dbErr);
          }
        } else {
          // API returned failure or empty
          if (!messages.length) setMessages([]);
        }
      } catch (err) {
        console.error("getMessages-> Failed to fetch messages: ", err);
        // If API fails, we still rely on local DB if we had it.
        // If we want to show error only if we have NO data:
        // if (!messages.length) setError("Failed to load messages");
      } finally {
        setLoding(false);
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        processChatGroupDetails(0, Number(clientId));
      } else {
        processChatGroupDetails(chatGroupId, Number(clientId));
      }
    };

    const handleBeforeUnload = () => {
      processChatGroupDetails(0, Number(clientId));
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);
    initializeListener();
    getMessages();

    return () => {
      isMounted = false;
      SignalR.removeListener(TAG);
      processChatGroupDetails(0, Number(clientId));
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [userId, chatGroupId, clientId]);

  function setListener() {
    BuildIdClientEventListener.onNewChatMessage(receivedNewMessage, TAG);
  }
  const receivedNewMessage = (data) => {
    const receivedNewMessage = data[0];
    if (receivedNewMessage.toChatGroupId == chatGroupId) {
      appendMessage(receivedNewMessage);
    }
  };
  function appendMessage(newMessage) {
    setMessages((msgs) => [...msgs, newMessage]);
  }

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const sendPictureMessages = async () => {
    for (let i = 0; i < selectedImages.length; i++) {
      const formData = new FormData();
      formData.append("ClientId", clientId);
      formData.append("FileName", selectedImages[i]);

      try {
        const response = await Fileuploadrequestcall(
          CLIENT_SAVE_MESSAGE_PITURES,
          formData,
          loginData?.accessToken
        );

        const picUrl = response.data.data[0];

        await send(MSG_TYPE.IMAGE, picUrl);
      } catch (error) {
        console.error("sendPictureMessages-> Error sending picture: ", error);
      }
    }
    setSelectedImages([]);
  };

  const handleSendMessage = async ({ text, images }) => {
    if (chatGroupId > 0) {
      if (images.length > 0) {
        await sendPictureMessages();
      }
      if (text) {
        await send(MSG_TYPE.TEXT, text);
      }
      return;
    }
  };

  const handleSendAudio = async (audioLink, audioDuration) => {
    if (!audioLink) {
      console.warn("ChatUI-> No audio link received.");
      return;
    }
    setAudioRecorder(false);
    if (chatGroupId > 0) {
      const payload = JSON.stringify({
        url: audioLink,
        duration: Number(audioDuration) || 0
      });
      await send(MSG_TYPE.AUDIO, payload);
    }
  };

  const sendChatNotification = async (chatGroupId, chatGroupName, body) => {
    const obj = {
      ChatGroupId: chatGroupId,
      ClientId: clientId,
      Notification: {
        ActionUrl: `mybuilderid://screenName=ClientConversationScreen&id=${chatGroupId}&ClientId=${clientId}`,
        title: chatGroupName,
        Body: body || "You have a new message",
        Tags: {
          chatGroupId: chatGroupId,
          chatGroupName: chatGroupName
        }
      }
    };
    try {
      await Postrequestcall(`${SEND_CHAT_GROUP_FIREBASE_NOTIFY}`, obj, loginData?.accessToken);
    } catch (error) {
      console.error("sendChatNotification-> Error sending chat notification: ", error);
    }
  };

  const send = async (msgType, msgBody, generatedChatGroupId = undefined) => {
    const groupId = generatedChatGroupId ? generatedChatGroupId : chatGroupId;
    const txtMsgArr = [
      Number(loginData?.userInformation?.UserId),
      loginData?.userInformation?.FirstName,
      loginData?.userInformation?.LastName,
      loginData?.pictureUrl,
      groupId,
      msgBody,
      msgType,
      loginData?.ChatLanguage,
      selectedClientData?.ClientId,
      selectedClientData?.ClientEmployeeId
    ];

    await buildIdEvent
      .sendClientMessage(txtMsgArr)
      .then(async (res) => {
        const chatGroupName = selectedChat?.groupDetails?.chatGroupName || "Client Chat";
        const notificationBody =
          msgType === MSG_TYPE.IMAGE
            ? "Sent an image"
            : msgType === MSG_TYPE.AUDIO
              ? "Sent a voice message"
              : msgBody;
        sendChatNotification(groupId, chatGroupName, notificationBody);
      })
      .catch((err) => {
        console.log("send-> : BuildIdEvent.sendClientMessage-> Error When Sening Message :", err);
      });
  };

  const removeImage = (index) => {
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      <ChatHeader selectedChat={selectedChat} onBack={onBack} isSmallScreen={isSmallScreen} />

      <Box ref={chatContainerRef} flexGrow={1} overflow="auto" bgcolor="#gray">
        {loading ? (
          <ChatLoader />
        ) : (
          <Message messages={messages} selectedChat={selectedChat} formClient="ClientChat" />
        )}
      </Box>

      {selectedImages.length != 0 && (
        <Stack>
          <Grid size={{ xs: 12, sm: 12, md: 12 }} sx={{ height: isSmallScreen ? 90 : 130 }}>
            <ImageList
              gap={7.5}
              sx={{
                width: "100%",
                height: "100%",
                margin: 0,
                padding: 0,
                flexWrap: "nowrap",
                overflowX: "auto",
                display: "flex",
                pb: 0.5,
                cursor: "pointer",
                borderRadius: "10px",
                backgroundColor: "white"
              }}>
              {selectedImages.map((picItem, picIndex) => (
                <ImageListItem key={picIndex} sx={{ minWidth: isSmallScreen ? 90 : 130 }}>
                  <img
                    src={picItem?.id ? picItem?.pictureUrl : URL.createObjectURL(picItem)}
                    style={{
                      borderRadius: 10,
                      width: isSmallScreen ? 90 : 130,
                      height: isSmallScreen ? 90 : 130,
                      objectFit: "cover",
                      cursor: "pointer"
                    }}
                    alt="Expenses"
                    loading="lazy"
                  />
                  <ImageListItemBar
                    sx={{ background: "none", padding: 1 }}
                    position="top"
                    actionIcon={
                      <IconButton
                        onClick={() => removeImage(picIndex)}
                        size="small"
                        sx={{
                          color: "white",
                          backgroundColor: "rgba(0,0,0,0.3)"
                        }}>
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    }
                    actionPosition="right"
                  />
                </ImageListItem>
              ))}
            </ImageList>
          </Grid>
        </Stack>
      )}

      <ChatInput
        onSendMessage={handleSendMessage}
        selectedImages={selectedImages}
        error={error}
        setError={setError}
        setSelectedImages={setSelectedImages}
        chatGroupId={chatGroupId}
        accentColor={selectedClientData?.AccentColor}
        onVoiceClick={() => setAudioRecorder(true)}
      />

      <ChatAudioRecorder
        isOpen={audioRecorder}
        onClose={() => setAudioRecorder(false)}
        sendAudio={handleSendAudio}
        uploadUrl={CLIENT_SAVE_CHAT_MEDIA_MASSAGES}
        clientId={clientId}
        accentColor={selectedClientData?.AccentColor || "#1976d2"}
        TEXT_RECORD_A_MASSAGE={"Record a message"}
        TEXT_SAVE={"Save"}
        TEXT_SEND={"Send"}
      />
    </>
  );
};

export default ChatUI;
